import React, { useEffect, useState } from "react";
import {
  useEditBookMutation,
  useGetBookQuery,
} from "../../features/api/apiSlice";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../ui/Error";
import Success from "../ui/Success";

const EditForm = () => {
  const { bookId } = useParams();
  const { data: bookInfo, isError } = useGetBookQuery(bookId);
  const navigate = useNavigate();
  const {
    id,
    name: initialName,
    author: initialAuthor,
    thumbnail: initialThumbnail,
    price: initialPrice,
    rating: initialRating,
    featured: initialFeatured,
  } = bookInfo || {};

  const [
    editBook,
    {
      data,
      isLoading: editMutationLoading,
      isError: editMutationError,
      isSuccess: editMutationSuccess,
    },
  ] = useEditBookMutation();

  const [name, setName] = useState("");
  const [author, setAuthor] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [price, setPrice] = useState("");
  const [rating, setRating] = useState(0);
  const [featured, setFeatured] = useState(false);

  const resetFrom = () => {
    setName("");
    setAuthor("");
    setThumbnail("");
    setPrice("");
    setRating(0);
    setFeatured(false);
  };

  const handleSubmitFunction = (e) => {
    e.preventDefault();
    if (id) {
      const data = {
        name,
        author,
        thumbnail,
        price: Number(price),
        rating: Number(rating),
        featured,
      };
      editBook({ id, data });
      navigate("/");
    }
  };

  useEffect(() => {
    if (id) {
      setName(initialName);
      setAuthor(initialAuthor);
      setThumbnail(initialThumbnail);
      setPrice(initialPrice);
      setRating(initialRating);
      setFeatured(initialFeatured);
    } else {
      resetFrom();
    }
  }, [id]);

  return (
    <div>
      <form className="book-form  mb-4" onSubmit={handleSubmitFunction}>
        <div className="space-y-2">
          <label htmlFor="lws-bookName">Book Name</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-bookName"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-author">Author</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-author"
            name="author"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="lws-thumbnail">Image Url</label>
          <input
            required
            className="text-input"
            type="text"
            id="lws-thumbnail"
            name="thumbnail"
            value={thumbnail}
            onChange={(e) => setThumbnail(e.target.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-8 pb-4">
          <div className="space-y-2">
            <label htmlFor="lws-price">Price</label>
            <input
              required
              type="number"
              className="text-input"
              id="lws-price"
              name="price"
              min={0}
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="lws-rating">Rating</label>
            <input
              required
              className="text-input"
              type="number"
              id="lws-rating"
              name="rating"
              min={1}
              max={5}
              value={rating}
              onChange={(e) => setRating(e.target.value)}
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            id="lws-featured"
            type="checkbox"
            name="featured"
            className="w-4 h-4"
            checked={featured}
            onChange={(e) => setFeatured(!featured)}
          />
          <label htmlFor="lws-featured" className="ml-2 text-sm">
            {" "}
            This is a featured book{" "}
          </label>
        </div>

        <button
          type="submit"
          className={`submit ${isError && "cursor-not-allowed"}`}
          id="lws-submit"
          disabled={!id || editMutationLoading}
        >
          Update
        </button>
      </form>
      {isError && <Error className="text-center" message="No Book Found" />}
      {editMutationSuccess && (
        <Success className="text-center" message="Updated successfully" />
      )}
    </div>
  );
};

export default EditForm;
